import {useLocation} from 'react-router-dom'

export const useIsLearningCenter = () => {
    const location = useLocation()
    return location.pathname.split('/').includes('learning-center')
}
